/* eslint-disable react/no-deprecated */
/* eslint-disable no-restricted-globals */
import { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import MuiListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import {
  mainColor,
  PAYMENT_TYPE_STRIPE,
  ORDER_TYPES,
  SUITABLE_TECHS,
  ALL_PAYMENT_TYPES,
  SUITABLE_PAYMENT_TYPES,
  ICON_PAYMENT,
  ICON_ORDER_TYPES,
  SUITABLE_ORDER_TYPES,
  SALES_TYPES,
  PAYMENTS_TYPES,
  settings,
  SAVE_BUTTON_TEXT,
  PAYMENT_TYPE_COUNTER,
} from '../../constants';
import Paper from '../Paper';
import Spinner from '../Spinner';
import Button from '../Button';
import BackButton from '../BackButton';
import Input from '../Input';
import Switch from '../Switch';
import * as actions from '../../actions/index';
import {
  handleToggle,
  handleSubmitData,
  initDataConfig,
  handleChangeInput,
  handleToggleDeliveryType
} from './PaymentAndOrderTypesConfig.service';
import { styles } from './PaymentAndOrderTypesConfig.styles';
import { checkAccess } from '../../utils/admins';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';

const ListItem = withStyles({
  root: {
    paddingLeft: '0px',
    paddingBottom: '5px',
    paddingTop: '0px',
    paddingRight: '0px'
  },
  button: {
    '&:hover': {
      backgroundColor: `rgba(${mainColor.rgb}, 0.6)`
    },
    width: 'auto',
    borderRadius: '6px',
    paddingTop: '8px',
    paddingBottom: '8px'
  }
})(MuiListItem);

const INITIAL_STATE = {
  checkedMethodTypes: {},
  methodTypesRef: {},
  isLoading: false,
  techs: {},
  updateModalConfig: false,
  updatePaimentModalConfig: false,
  checkedDeliveryTypes: {}
};
class PaymentAndOrderTypesConfig extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  async componentDidMount() {
    await initDataConfig(this.props, this);
  }

  async componentWillReceiveProps(nextProps) {
    const {
      configurations: oldConfigs = {},
      isAllShops: oldIsAllShops,
      orderTypes: oldConfigOrderTYpes,
      delivery: oldDelivery = {}
    } = this.props;
    const {
      configurations = {},
      isAllShops,
      orderTypes: configOrderTYpes,
      delivery = {}
    } = nextProps;
    const { chatbot, terminal, mobileApp, qrcode, webapp, configuration = {} } = configurations;
    const { orderTypes = [], refs = {}, paymentTypes } = configuration;
    const {
      chatbot: oldChatbot,
      terminal: oldTerminal,
      mobileApp: oldMobileApp,
      qrcode: oldQrCode,
      webapp: oldWebapp,
      configuration: oldConfig = {}
    } = oldConfigs;
    const {
      orderTypes: oldOrderTypes = [],
      refs: oldRefs = {},
      paymentTypes: oldPaymentTypes
    } = oldConfig;
    const { paymentTypes: oldDeliveryPaymentTypes = {} } = oldDelivery;
    const { paymentTypes: deliveryPaymentTypes = {} } = delivery;
    if (
      !_.isEqual(oldChatbot, chatbot) ||
      !_.isEqual(oldPaymentTypes, paymentTypes) ||
      !_.isEqual(oldTerminal, terminal) ||
      !_.isEqual(oldMobileApp, mobileApp) ||
      !_.isEqual(oldQrCode, qrcode) ||
      !_.isEqual(oldWebapp, webapp) ||
      !_.isEqual(oldOrderTypes, orderTypes) ||
      !_.isEqual(oldRefs, refs) ||
      !_.isEqual(oldIsAllShops, isAllShops) ||
      !_.isEqual(oldConfigOrderTYpes, configOrderTYpes) ||
      !_.isEqual(oldDeliveryPaymentTypes, deliveryPaymentTypes)
    ) {
      await initDataConfig(nextProps, this);
    }
  }

  renderConfigSwitch = type => {
    const { classes, mobileApp, webapp, chatbot, isAllShops, nbShops } = this.props;
    const { techs, checkedMethodTypes = {}, methodTypesRef = {} } = this.state;
    const deliveryTech = mobileApp.enabled || webapp.enabled;
    const toCheck = checkedMethodTypes;
    const listData = type === SALES_TYPES ? ORDER_TYPES : ALL_PAYMENT_TYPES;
    const icons = type === SALES_TYPES ? ICON_ORDER_TYPES : ICON_PAYMENT;
    const suitableData = type === SALES_TYPES ? SUITABLE_ORDER_TYPES : SUITABLE_PAYMENT_TYPES;
    const returnComponents = [];
    techs &&
      _.map(techs, (tech, key) => {
        returnComponents.push(
          <div
            className={`row m-0 p-3 p-sm-4 ${key === SUITABLE_TECHS.qrcode && (!hasExternalIntegration() || isAllShops)
              ? ''
              : classes.root
              }`}
          >
            <div className="col-sm-4 mt-2">
              {!(type === PAYMENTS_TYPES && key === SUITABLE_TECHS.webapp) && <p className={classes.boldText}>{key} :</p>}
            </div>
            <div className="col-sm-8">
              {type === PAYMENTS_TYPES &&
                key === SUITABLE_TECHS.webapp && (
                  <p className={classes.boldText} style={{ color: 'black' }}>
                    Modes de vente sur place et emporter :
                  </p>
                )}
              <List>
                {(checkIntegrationAccess('paymentType', 'displayCounterType') ? listData[key] : listData[key].filter(i => i !== PAYMENT_TYPE_COUNTER)).map(e => {
                  return (
                    <ListItem>
                      <ListItemIcon style={{ minWidth: 36 }}>{icons[e]}</ListItemIcon>
                      <ListItemText
                        className={classes.itemText}
                        primary={
                          e === 'counter' &&
                            key === SUITABLE_TECHS.webapp &&
                            type === PAYMENTS_TYPES
                            ? SUITABLE_ORDER_TYPES.click_and_seat
                            : suitableData[e]
                        }
                      />
                      <ListItemSecondaryAction style={{ right: -12 }}>
                        <Switch
                          className={classes.switch}
                          onChange={handleToggle(e, key, type, this)}
                          checked={toCheck[key].indexOf(e) !== -1}
                          color="primary"
                          disabled={
                            !tech ||
                            e === PAYMENT_TYPE_STRIPE ||
                            ((key === SUITABLE_TECHS.terminal || key === SUITABLE_TECHS.qrcode) &&
                              (type === SALES_TYPES || (!isAllShops && nbShops > 1))) ||
                            (!checkAccess('features', 'paymentType') &&
                              deliveryTech &&
                              key !== SUITABLE_TECHS.webapp &&
                              type === PAYMENTS_TYPES)
                          }
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          </div>
        );
      });

    hasExternalIntegration() &&
      !isAllShops &&
      returnComponents.push(
        <div className="row m-0 p-3 p-sm-4">
          <div className="col-sm-4  mt-2">
            <h5 className={classes.boldText}>Références :</h5>
          </div>
          <div className="col-sm-8">
            {_.map(suitableData, (element, key) => {
              return (
                <Input
                  margin="dense"
                  label={`${type === SALES_TYPES ? `Référence du mode` : `Référence`
                    } ${suitableData[key].toLowerCase()}`}
                  id="methodTypesRef"
                  value={
                    _.find(methodTypesRef, elt => elt.key === key)
                      ? _.find(methodTypesRef, elt => elt.key === key).ref
                      : ''
                  }
                  fullWidth
                  onChange={event => handleChangeInput(key, event, this)}
                />
              );
            })}
          </div>
        </div>
      );
    return returnComponents;
  };

  renderDeliveryPaymentTypes = () => {
    const { classes, userPermissions } = this.props;
    const { checkedDeliveryTypes = {} } = this.state;
    const toCheck = checkedDeliveryTypes;
    const listData = ALL_PAYMENT_TYPES[SUITABLE_TECHS.webapp].filter(
      i => i !== PAYMENT_TYPE_COUNTER
    );
    const icons = ICON_PAYMENT;
    const suitableData = SUITABLE_PAYMENT_TYPES;
    return (
      <div className={`row m-0 p-3 p-sm-4 ${classes.space}`}>
        <div className="col-sm-4 mt-2">
          <p className={classes.boldText}>{SUITABLE_TECHS.webapp} :</p>
        </div>
        <div className="col-sm-8 mt-2">
          <p className={classes.boldText} style={{ color: 'black' }}>
            Mode de vente livraison :
          </p>
          <List>
            {listData.map(e => {
              return (
                <ListItem>
                  <ListItemIcon style={{ minWidth: 36 }}>{icons[e]}</ListItemIcon>
                  <ListItemText className={classes.itemText} primary={suitableData[e]} />
                  <ListItemSecondaryAction style={{ right: -12 }}>
                    <Switch
                      className={classes.switch}
                      onChange={handleToggleDeliveryType(e, SUITABLE_TECHS.webapp, this)}
                      checked={
                        e === PAYMENT_TYPE_STRIPE
                          ? true
                          : _.size(toCheck[SUITABLE_TECHS.webapp]) > 0
                            ? toCheck[SUITABLE_TECHS.webapp].indexOf(e) !== -1
                            : false
                      }
                      color="primary"
                      disabled={e === PAYMENT_TYPE_STRIPE || userPermissions?.isAdminOfThisShop}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </div>
      </div>
    );
  };

  render() {
    const { type, isLoading } = this.state;
    const { history, sidebarCollapse } = this.props;
    return (
      <div className="p-4">
        <BackButton
          className="pl-0"
          onClick={() => history.goBack()}
          title={type === SALES_TYPES ? settings.orderTypes.text : settings.paymentTypes.text}
          subtitle={
            type === SALES_TYPES
              ? settings.orderTypes.description
              : settings.paymentTypes.description
          }
        />
        <Paper className={`col-12 ${sidebarCollapse && 'col-lg-10'} px-0 mt-3`}>
          {type === PAYMENTS_TYPES && this.renderDeliveryPaymentTypes()}
          {this.renderConfigSwitch(type)}
          <div className="d-flex w-100 justify-content-center justify-content-sm-end align-items-center p-4">
            <div className={`px-sm-${isLoading ? 5 : 2} `}>
              {isLoading ? (
                <Spinner size={30} />
              ) : (
                <Button
                  color="primary"
                  onClick={e => handleSubmitData(e, type, this)}
                  className="btn-primary"
                >
                  <div className="row justify-content-center align-items-center mr-0 ml-0">
                    <p className="mx-0">{SAVE_BUTTON_TEXT}</p>
                  </div>
                </Button>
              )}
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, sidebar, user }) {
  const { generalConfig, shop } = firebaseRealTime;
  const { isAllShops, nbShops, userPermissions } = user;
  const {
    chatbot = {},
    terminal = {},
    paymentTypes = {},
    mobileApp = {},
    qrcode = {},
    webapp = {},
    orderTypes = {},
    delivery = {}
  } = generalConfig;
  const { sidebarCollapse } = sidebar;
  return {
    configurations: shop,
    chatbot,
    paymentTypes,
    terminal,
    mobileApp,
    qrcode,
    webapp,
    sidebarCollapse,
    orderTypes,
    isAllShops,
    userPermissions,
    nbShops,
    delivery
  };
}
PaymentAndOrderTypesConfig.propTypes = {
  classes: PropTypes.element.isRequired
};
export default connect(
  mapStateToProps,
  actions
)(withStyles(styles)(withRouter(PaymentAndOrderTypesConfig)));
